export const createHostedMarketplaceConfigAsset = (hostedConfig = {}) => {
  return {
    ...hostedConfig,
    categories: hostedConfig?.categories || {},
    listingTypes: hostedConfig?.listingTypes || {},
    listingFields: hostedConfig?.listingFields || {},
    search: hostedConfig?.search || {},
  };
};

